<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="editLanguages">
        <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
          <v-layout wrap>
            <v-flex xs12 class="primary white--text" text-center>
              <h3>
                <span>{{ $t('a') }}</span>
                <v-icon small class="ml-2" :class="{ 'white--text': hover, 'primary--text': !hover }">mdi-pen</v-icon>
              </h3>
            </v-flex>
          </v-layout>
        </v-banner>
        <v-divider/>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout wrap v-for="(language, key) in dossier.profile.languages" :key="key">
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs3 class="leftCell" pl-1>
                    {{ getLanguageName(language.code) }}
                  </v-flex>
                  <v-flex xs9 pl-2>
                    {{ getLanguageLevel(language.levelNb) }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-divider/>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="dossier.profile.languages.length === 0">
              <v-flex xs3>
              </v-flex>
              <v-flex xs9 pl-2>
                <i>{{ $t('b') }}</i>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-hover>
  </div>
</template>

<script>
const allLanguages = require('@/assets/app/data/languages.json')
const textkernelLanguageLevels = require('@/assets/app/data/textkernelLanguageLevels.json')

import { mapGetters } from "vuex";

export default {
  props: {
    dossier: Object
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    editLanguages() {
      this.$emit('setFieldPath', { fieldPath: ['languages'], savedScrollEltId: `view-languages` })
    },
    getLanguageName(code) {
      return code ? allLanguages.find(language => language.iso_code === code).descriptions[this.user.data.locale] : ''
    },
    getLanguageLevel(levelNb) {
      return levelNb !== null ? textkernelLanguageLevels.find(lang => lang.levelNb === levelNb)[this.user.data.locale] : ''
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Langues",
    "b": "Aucune langue."
  },
  "en": {
    "a": "Languages",
    "b": "No language."
  }
}
</i18n>